import React, { useState } from "react";
import { reportError } from "../../utils/errorReporting";

export interface SendTestButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  channel: "SMS" | "Email" | "Push";
  device?: string | null;
  sendTestNotification: (
    channel: "SMS" | "Email" | "Push",
    device?: string | null,
  ) => Promise<void>;
  cooldown?: number;
  className?: string;
  children?: React.ReactNode;
}

const SendTestButton: React.FC<SendTestButtonProps> = ({
  channel,
  device = null,
  sendTestNotification,
  cooldown = 10000,
  className,
  children,
  ...rest
}) => {
  const [isSending, setIsSending] = useState(false);

  const handleSendTest = async () => {
    setIsSending(true);
    try {
      await sendTestNotification(channel, device);
    } catch (error) {
      reportError(error, { error_source: "handled" });
    } finally {
      setTimeout(() => {
        setIsSending(false);
      }, cooldown);
    }
  };

  return (
    <button
      disabled={isSending}
      className={className}
      {...rest}
      onClick={handleSendTest}
    >
      {isSending ? "Sending..." : children || "Send Test"}
    </button>
  );
};

export default SendTestButton;
